import { createFileRoute } from '@tanstack/react-router'
import { parseKnowledgeBaseKbIdSearch } from '@/components/knowledge/knowledgeBaseRouteSearch'

/** KB file list is rendered by `/_app/knowledge-base/$kbId` layout (`KnowledgeBaseView`). */
export const Route = createFileRoute('/_app/knowledge-base/$kbId/')({
  validateSearch: (search: Record<string, unknown>) =>
    parseKnowledgeBaseKbIdSearch(search),
  component: () => null,
})
